import React from 'react';
import { graphql } from 'gatsby';
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews';
import Post, { PostProps } from '@components/post';

const CaseStudiesPostPage = ({ data }: PostProps): JSX.Element => <Post data={data} />;

export default withPrismicPreview(CaseStudiesPostPage);

export const query = graphql`
  query CaseStudiesPostQuery($uid: String, $categoriesArray: [String]) {
    prismicGeneralConfig {
      ...GeneralConfigFragment
    }
    prismicPostPageConfig {
      ...PostPageConfigFragment
    }
    currentPost: allPrismicCaseStudiesPost(filter: { uid: { eq: $uid } }) {
      edges {
        node {
          ...CaseStudiesPostFragment
        }
      }
    }
    relativePosts: allPrismicCaseStudiesPost(
      filter: { tags: { in: $categoriesArray }, uid: { ne: $uid } }
      limit: 3
      sort: { fields: first_publication_date, order: DESC }
    ) {
      edges {
        node {
          ...CaseStudiesPostPreviewFragment
        }
      }
    }
    restPosts: allPrismicCaseStudiesPost(
      filter: { uid: { ne: $uid } }
      limit: 3
      sort: { fields: first_publication_date, order: DESC }
    ) {
      edges {
        node {
          ...CaseStudiesPostPreviewFragment
        }
      }
    }
  }
`;
